import TutorService from "../services/TutorService";
import StoreRepository from "../repositories/StoreRepository";
import ComparatorService from "../services/ComparatorService";
export default class TutorManager {
    constructor(tutors) {
        this._tutorService = new TutorService();
        this._tutorRepository = new StoreRepository();
        this._comparatorService = new ComparatorService();
        Object.keys(tutors).forEach(key => {
            let tutor = this._tutorService.mapInterfaceToModel(tutors[key]);
            this._tutorRepository.storeItem(tutor);
        });
    }
    getTutors() {
        let store = this._tutorRepository.getStore();
        let array = [];
        Object.keys(store).forEach(key => {
            array.push(store[key]);
        });
        return array;
    }
    getTutorsSorted() {
        return this.getTutors().sort(this._comparatorService.compareByName);
    }
    get tutorService() {
        return this._tutorService;
    }
    set tutorService(value) {
        this._tutorService = value;
    }
    get tutorRepository() {
        return this._tutorRepository;
    }
    set tutorRepository(value) {
        this._tutorRepository = value;
    }
}
